module.exports = __webpack_public_path__ + "img/new_37.fa5f639f.jpg";